// Full-page shimmer skeleton shown at startup (while the user/session loads)
// in place of the old full-page spinner. Reuses the real shell classes
// (.gos-sidebar / .gos-shell-main / .gos-scroll-body) so it sizes identically,
// plus the global .gos-skel-* shimmer atoms.
const NavRows = () =>
  Array.from({ length: 8 }).map((_, i) => (
    <div className="gos-sb-skel-item" key={i}>
      <span className="gos-skel-box gos-skel-an" style={{ width: 32, height: 32, borderRadius: 9 }} />
      <span className="gos-skel-bar gos-skel-an" style={{ width: '58%' }} />
    </div>
  ));

const AppShellSkeleton = () => (
  <section>
    <div className="crm_dashboard flex_clmn gos-app" id="CRM_pageSection">
      {/* sidebar */}
      <div className="gos-sidebar">
        <div className="gos-sb-brand">
          <div className="gos-sb-logo">
            <span className="gos-skel-box gos-skel-an" style={{ width: 26, height: 26, borderRadius: 7 }} />
          </div>
          <span className="gos-skel-bar gos-skel-an" style={{ width: 92, height: 14 }} />
        </div>
        <div className="gos-sb-section">Workspace</div>
        <nav className="gos-sb-nav">
          <NavRows />
        </nav>
        <div className="gos-sb-foot">
          <div className="gos-sb-user">
            <span className="gos-skel-avatar gos-skel-an" style={{ width: 38, height: 38 }} />
            <div className="gos-sb-user-meta" style={{ flex: 1 }}>
              <span className="gos-skel-bar gos-skel-an" style={{ width: '70%' }} />
              <span className="gos-skel-bar gos-skel-an sm" style={{ width: '90%', marginTop: 7 }} />
            </div>
          </div>
        </div>
      </div>

      {/* main shell */}
      <div className="gos-shell-main">
        <div className="gos-skel-topbar">
          <span className="gos-skel-bar gos-skel-an" style={{ width: 220, height: 14 }} />
          <div className="gos-skel-topbar-r">
            <span className="gos-skel-box gos-skel-an" />
            <span className="gos-skel-box gos-skel-an" />
            <span className="gos-skel-box gos-skel-an" />
          </div>
        </div>
        <div className="gos-scroll-body">
          <div className="dashboard_container" style={{ marginLeft: 0 }}>
            <div className="inner-page">
              <div className="home-content">
                {/* page head */}
                <div className="gos-page-head">
                  <div>
                    <span className="gos-skel-bar gos-skel-an" style={{ width: 260, height: 20 }} />
                    <span className="gos-skel-bar gos-skel-an sm" style={{ width: 320, marginTop: 11 }} />
                  </div>
                  <div className="gos-skel-head-actions">
                    <span className="gos-skel-bar gos-skel-an" style={{ width: 150, height: 38, borderRadius: 9 }} />
                    <span className="gos-skel-bar gos-skel-an" style={{ width: 120, height: 38, borderRadius: 9 }} />
                  </div>
                </div>

                {/* KPI row */}
                <div className="flex_boxes">
                  <div className="grid-container-box">
                    {Array.from({ length: 4 }).map((_, i) => (
                      <div className="grid-box gos-kpi" key={i}>
                        <div className="gos-kpi-top">
                          <span className="gos-skel-box gos-skel-an" style={{ width: 42, height: 42, borderRadius: 12 }} />
                          <span className="gos-skel-bar gos-skel-an" style={{ width: 76, height: 30, borderRadius: 8 }} />
                        </div>
                        <span className="gos-skel-bar gos-skel-an sm" style={{ width: '52%', marginTop: 16 }} />
                        <span className="gos-skel-bar gos-skel-an" style={{ width: '38%', height: 22, marginTop: 12 }} />
                      </div>
                    ))}
                  </div>
                </div>

                {/* two content cards */}
                <div className="gos-graphs">
                  <div className="gos-dash-2col">
                    {Array.from({ length: 2 }).map((_, i) => (
                      <div className="card gos-card" key={i}>
                        <div className="gos-card-head">
                          <span className="gos-skel-bar gos-skel-an" style={{ width: 150, height: 13 }} />
                          <span className="gos-skel-bar gos-skel-an sm" style={{ width: 70 }} />
                        </div>
                        <div className="gos-card-pad gos-skel-graph">
                          {Array.from({ length: 5 }).map((_, j) => (
                            <span className="gos-skel-bar gos-skel-an" key={j} style={{ width: `${82 - j * 12}%` }} />
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AppShellSkeleton;
